import { MIN_ORDER_COST_USDT } from "../constants";
import { capToBalance } from "./format";

/** Chip result: below the minimum any chip snaps to it; otherwise the value is capped to the balance but never under the minimum. */
export const applyWagerChip = (wager, multiplier, availableBalance) => {
  if (wager < MIN_ORDER_COST_USDT) return MIN_ORDER_COST_USDT;

  return Math.max(capToBalance(wager * multiplier, availableBalance), MIN_ORDER_COST_USDT);
};
